import React, { useState, Component } from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
import { Star, StarHalf } from 'lucide-react';
const initialTestimonials = [{
  id: 1,
  name: 'Melissa R.',
  location: 'Austin, TX',
  rating: 4,
  text: "I'll be honest — I was skeptical. I've tried manifestation before and nothing ever stuck. But I did the script for 7 nights and my ex — who hadn't texted in 4 months — reached out. I'm not saying it's magic... but I'm not NOT saying that either. Taking one star off only because I wanted more scripts in the pack.",
  img: 'https://randomuser.me/api/portraits/women/44.jpg'
}, {
  id: 2,
  name: 'Danielle F.',
  location: 'Chicago, IL',
  rating: 4.5,
  text: "This is the most peaceful I've felt at bedtime in years. I stopped dreading the nighttime spiral the same week I started using this. The Cord Release script made me cry (in a good way). I've already recommended it to my sister. Worth every penny and then some.",
  img: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  id: 3,
  name: 'Carmen V.',
  location: 'Miami, FL',
  rating: 5,
  text: "I met someone three weeks after starting the protocol. I know that sounds insane, but here I am. He is everything I wrote in the script. Patient, emotionally available, consistent. I genuinely believe this shifted something deep in me. If you're on the fence — just get it. It's $6. What do you have to lose?",
  img: 'https://randomuser.me/api/portraits/women/32.jpg'
}, {
  id: 4,
  name: 'Jessica T.',
  location: 'New York, NY',
  rating: 5,
  text: "Absolutely incredible. My specific person reached out after 4 days of listening. I've never felt so magnetic and calm in my entire life.",
  img: 'https://randomuser.me/api/portraits/women/12.jpg'
}, {
  id: 5,
  name: 'Amanda L.',
  location: 'Denver, CO',
  rating: 4.5,
  text: 'The cord release script is so powerful. I feel lighter. I finally stopped checking his social media and he actually texted me first yesterday.',
  img: 'https://randomuser.me/api/portraits/women/24.jpg'
}, {
  id: 6,
  name: 'Sophia M.',
  location: 'Seattle, WA',
  rating: 4,
  text: 'It takes a few days to get used to, but the results are undeniable. My energy has completely shifted from anxious to secure.',
  img: 'https://randomuser.me/api/portraits/women/19.jpg'
}];
const StarRating = ({
  rating
}: {
  rating: number;
}) => {
  return <div className="flex gap-1 mb-4" data-id="element-261">
      {[1, 2, 3, 4, 5].map(star => {
      if (star <= Math.floor(rating)) {
        return <Star key={star} className="w-4 h-4 text-gold fill-gold" data-id="element-262" />;
      } else if (star === Math.ceil(rating) && rating % 1 !== 0) {
        return <div key={star} className="relative w-4 h-4" data-id="element-263">
              <Star className="absolute top-0 left-0 w-4 h-4 text-gray-600" data-id="element-264" />
              <div className="absolute top-0 left-0 w-2 h-4 overflow-hidden" data-id="element-265">
                <Star className="w-4 h-4 text-gold fill-gold" data-id="element-266" />
              </div>
            </div>;
      } else {
        return <Star key={star} className="w-4 h-4 text-gray-600" data-id="element-267" />;
      }
    })}
    </div>;
};
export function TestimonialsSection() {
  const [reviews, setReviews] = useState(initialTestimonials);
  const [newReview, setNewReview] = useState({
    name: '',
    text: '',
    rating: 5
  });
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newReview.name || !newReview.text) return;
    const review = {
      id: Date.now(),
      name: newReview.name,
      location: 'Just now',
      rating: newReview.rating,
      text: newReview.text,
      img: 'https://ui-avatars.com/api/?name=' + encodeURIComponent(newReview.name) + '&background=130825&color=C9A84C'
    };
    setReviews([review, ...reviews]);
    setSubmitted(true);
    setNewReview({
      name: '',
      text: '',
      rating: 5
    });
    setTimeout(() => setSubmitted(false), 4000);
  };
  return <section className="bg-cosmic-dark relative z-10 py-12 px-0 overflow-hidden" data-id="element-268">
      <ScrollReveal className="max-w-6xl mx-auto flex flex-col items-center px-6" data-id="element-269">
        <p className="text-gold uppercase tracking-widest text-sm font-semibold mb-12 text-center" data-id="element-270">
          What Women Are Saying
        </p>

        {/* Golden Fixed Audio Testimonial */}
        <div className="w-full max-w-3xl bg-gradient-to-br from-[#2A1B0A] to-cosmic-card border-2 border-gold rounded-2xl p-6 md:p-10 mb-16 shadow-[0_0_40px_rgba(201,168,76,0.25)] relative" data-id="element-271">
          <div className="absolute top-0 right-0 bg-gold text-cosmic-black text-xs font-bold px-4 py-1 rounded-bl-lg rounded-tr-xl tracking-wider" data-id="element-272">
            FEATURED STORY
          </div>

          <div className="flex flex-col md:flex-row items-center md:items-start gap-6 mb-6" data-id="element-273">
            <img src="https://randomuser.me/api/portraits/women/45.jpg" alt="Sarah" className="w-20 h-20 rounded-full border-2 border-gold shadow-[0_0_15px_rgba(201,168,76,0.5)]" data-id="element-274" />
            <div className="text-center md:text-left" data-id="element-275">
              <h3 className="text-2xl font-playfair font-bold text-gold mb-1" data-id="element-276">
                Sarah's Manifestation
              </h3>
              <StarRating rating={5} data-id="element-277" />
              <p className="text-lunar-white italic text-lg leading-relaxed" data-id="element-278">
                "I was literally shaking... I found him because of a 3-minute
                script I found at 2 AM. Listen to my full story below."
              </p>
            </div>
          </div>

          <div className="w-full bg-cosmic-black/50 p-4 rounded-xl border border-gold/30" data-id="element-279">
            <p className="text-gold text-xs uppercase tracking-widest mb-2 font-semibold" data-id="element-280">
              Press Play to Listen
            </p>
            <audio controls className="w-full h-10 rounded-lg outline-none" data-id="element-281">
              <source src="https://cdn.magicpatterns.com/uploads/fJmFBVvzDnoLh3vbd8m8gu/202603161853.mp4" type="audio/mp4" data-id="element-282" />
              Your browser does not support the audio element.
            </audio>
          </div>
        </div>
      </ScrollReveal>

      {/* Marquee Carousel */}
      <div className="relative w-full py-4 mb-20" data-id="element-283">
        <div className="absolute top-0 bottom-0 left-0 w-16 md:w-40 bg-gradient-to-r from-cosmic-dark to-transparent z-10 pointer-events-none" data-id="element-284"></div>
        <div className="absolute top-0 bottom-0 right-0 w-16 md:w-40 bg-gradient-to-l from-cosmic-dark to-transparent z-10 pointer-events-none" data-id="element-285"></div>

        <div className="animate-marquee" data-id="element-286">
          {/* Render twice for infinite scroll effect */}
          {[...reviews, ...reviews].map((review, idx) => <div key={`${review.id}-${idx}`} className="w-[320px] md:w-[400px] flex-shrink-0 testimonial-card bg-cosmic-deep border-t-[3px] border-gold rounded-2xl p-8 flex flex-col mx-4 relative" data-id="element-287">
              <StarRating rating={review.rating} data-id="element-288" />
              <p className="text-lunar-white text-base leading-relaxed mb-8 flex-grow italic" data-id="element-289">
                "{review.text}"
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-290">
                <img src={review.img} alt={review.name} className="w-12 h-12 rounded-full border border-gold/50 object-cover" data-id="element-291" />
                <div data-id="element-292">
                  <p className="text-lunar-white font-bold text-sm" data-id="element-293">
                    {review.name}
                  </p>
                  <p className="text-lunar-muted text-xs" data-id="element-294">{review.location}</p>
                </div>
              </div>
              <div className="absolute top-6 right-6 text-gold text-xs font-semibold tracking-wider" data-id="element-295">
                ✦ Verified
              </div>
            </div>)}
        </div>
      </div>

      {/* Leave a Review Form */}
      <ScrollReveal className="max-w-2xl mx-auto px-6" data-id="element-296">
        <div className="bg-cosmic-card border border-violet/30 rounded-2xl p-8 shadow-lg" data-id="element-297">
          <h3 className="font-playfair text-2xl text-lunar-white font-bold mb-2 text-center" data-id="element-298">
            Share Your Experience
          </h3>
          <p className="text-lunar-muted text-sm text-center mb-6" data-id="element-299">
            Join thousands of women who have shifted their reality.
          </p>

          {submitted ? <div className="bg-green-900/30 border border-green-500/50 text-green-200 p-4 rounded-lg text-center animate-fade-in" data-id="element-300">
              Thank you! Your review has been published successfully.
            </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-301">
              <div data-id="element-302">
                <label className="block text-lunar-lavender text-sm mb-1" data-id="element-303">
                  Your Name
                </label>
                <input type="text" required value={newReview.name} onChange={e => setNewReview({
              ...newReview,
              name: e.target.value
            })} className="w-full bg-cosmic-deep border border-white/10 rounded-lg px-4 py-2 text-lunar-white focus:outline-none focus:border-gold transition-colors" placeholder="e.g. Sarah M." data-id="element-304" />
              </div>

              <div data-id="element-305">
                <label className="block text-lunar-lavender text-sm mb-1" data-id="element-306">
                  Rating
                </label>
                <select value={newReview.rating} onChange={e => setNewReview({
              ...newReview,
              rating: Number(e.target.value)
            })} className="w-full bg-cosmic-deep border border-white/10 rounded-lg px-4 py-2 text-lunar-white focus:outline-none focus:border-gold transition-colors appearance-none" data-id="element-307">
                  <option value={5} data-id="element-308">5 Stars - Life Changing</option>
                  <option value={4.5} data-id="element-309">4.5 Stars - Amazing</option>
                  <option value={4} data-id="element-310">4 Stars - Great Results</option>
                  <option value={3} data-id="element-311">3 Stars - Good</option>
                  <option value={2} data-id="element-312">2 Stars - Okay</option>
                  <option value={1} data-id="element-313">1 Star - Not for me</option>
                </select>
              </div>

              <div data-id="element-314">
                <label className="block text-lunar-lavender text-sm mb-1" data-id="element-315">
                  Your Story
                </label>
                <textarea required value={newReview.text} onChange={e => setNewReview({
              ...newReview,
              text: e.target.value
            })} rows={4} className="w-full bg-cosmic-deep border border-white/10 rounded-lg px-4 py-2 text-lunar-white focus:outline-none focus:border-gold transition-colors resize-none" placeholder="How did the script work for you?" data-id="element-316"></textarea>
              </div>

              <button type="submit" className="w-full bg-violet text-white font-bold py-3 rounded-lg hover:bg-electric transition-colors shadow-[0_0_15px_rgba(123,47,190,0.4)]" data-id="element-317">
                Publish Review
              </button>
            </form>}
        </div>
      </ScrollReveal>
    </section>;
}